import { Outlet } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { ClientApplicationTabs } from "@components/Tabs";

import { PortalSubNavigationTabs } from "@layouts/PortalPage/PortalSubNavigationTabs";

import { routes } from "@pages/routes";

export const Application = () => {
  const { clientId, applicationId } = useTypedParams(
    routes.portal.clients.client.applications.application,
  );

  return (
    <>
      <PortalSubNavigationTabs>
        <ClientApplicationTabs
          clientId={clientId}
          clientApplicationId={applicationId}
        />
      </PortalSubNavigationTabs>
      <Outlet />
    </>
  );
};
